import { render } from "./CameraPic.vue?vue&type=template&id=12a6842c&scoped=true"
import script from "./CameraPic.vue?vue&type=script&lang=js"
export * from "./CameraPic.vue?vue&type=script&lang=js"

import "./CameraPic.vue?vue&type=style&index=0&id=12a6842c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a6842c"]])

export default __exports__